import { registerSignaturePadWithInviteQuestion } from './signaturepad-with-invite';
import { registerTermsQuestion } from './terms';
import { registerCaptchaQuestion } from './captcha';
import { registerFilePreviewComponent } from './file-preview-component';
import { registerTradeReferencesQuestion } from './trade-references';
import {
  SurveySettings, Submission,
} from '../../types';

interface RegisterCustomSurveyQuestionsProps {
  settings: SurveySettings;
  submission?: Submission;
  isSigner: boolean;
}

export function registerCustomSurveyQuestions ({
  settings, submission, isSigner,
}: RegisterCustomSurveyQuestionsProps): void {
  registerSignaturePadWithInviteQuestion({
    settings,
    submission,
    isSigner,
  });
  registerTradeReferencesQuestion();
  registerTermsQuestion();
  registerCaptchaQuestion();
  registerFilePreviewComponent();
}
